import _ from 'lodash';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import ReactDOM from 'react-dom';
import { Key } from 'w3c-keys';
import styles from './popover.module.scss';
import { PopoverUtil } from './popover-utils';
const PopoverPositionableComponent = ({ position, content, align, isVisible, showAlignArrow = false, appendToBody = true, setToggle = _.noop, targetRef = null, }, ref) => {
    const [postionRef, setPositionRef] = useState(null);
    const popperRef = useRef(null);
    const { width = 10, height = 10, top, left, bottom, right } = position || {};
    useImperativeHandle(ref, () => ({
        resizePopover: () => {
            window.dispatchEvent(new Event('resize'));
        },
    }));
    /**
     * Hide popper if we click anywhere OUTSIDE
     * the popper or the target node
     */
    const handleDocumentClick = (event) => {
        const isInsidePopper = popperRef &&
            popperRef.current &&
            popperRef.current.contains(event.target);
        if (isInsidePopper) {
            return;
        }
        setToggle(false);
    };
    const onEscapeHandler = (event) => {
        if (event.key === Key.Escape) {
            setToggle(false);
        }
    };
    useEffect(() => {
        const virtualReference = {
            getBoundingClientRect() {
                return {
                    width,
                    height,
                    top,
                    left,
                    bottom,
                    right,
                };
            },
        };
        setPositionRef(virtualReference);
    }, [bottom, height, left, position, right, top, width]);
    useEffect(() => {
        document.addEventListener('mousedown', handleDocumentClick);
        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bottom, height, left, position, right, top, width, popperRef]);
    useEffect(() => {
        document.addEventListener('keydown', onEscapeHandler);
        return () => {
            document.removeEventListener('keydown', onEscapeHandler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { renderPopoverContent } = PopoverUtil(targetRef !== null && targetRef !== void 0 ? targetRef : postionRef, styles, {
        content,
        appendToBody,
        align,
        showAlignArrow,
        isVisible,
        popperRef,
    });
    return (React.createElement(React.Fragment, null, appendToBody
        ? ReactDOM.createPortal(renderPopoverContent(), document.body)
        : renderPopoverContent()));
};
export const PopoverPositionable = forwardRef(PopoverPositionableComponent);
//# sourceMappingURL=popover-positionable.js.map